import React, { useEffect, useState, useCallback } from 'react';
import { getMyStats, getPaper, errMsg } from './aiPaperApi';
import FileTable from './FileTable';
import { ui } from './ui';

const fmt = (d) => new Date(d).toLocaleString('en-IN', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
const Stat = ({ label, value, color }) => (
  <div style={{ flex: '1 1 110px', background: '#fff', border: `2px solid ${color}`, borderRadius: 12, padding: '10px 12px', textAlign: 'center' }}>
    <div style={{ fontSize: 26, fontWeight: 900, color }}>{value}</div>
    <div style={{ fontSize: 11.5, fontWeight: 700, color: '#475569' }}>{label}</div>
  </div>
);

// Stat block for the teacher's profile: totals + recent history + own uploaded files.
// `reloadKey` lets the parent refresh it after generating / downloading.
function TeacherPaperStats({ user, reloadKey = 0, onOpenPaper }) {
  const [stats, setStats] = useState(null);
  const [err, setErr] = useState('');
  const [showFiles, setShowFiles] = useState(false);

  const load = useCallback(() => {
    getMyStats(user).then(setStats).catch((e) => setErr(errMsg(e)));
  }, [user]);
  useEffect(() => { load(); }, [load, reloadKey]);

  if (err) return <div style={ui.errorBox}>{err}</div>;
  if (!stats) return <div style={{ fontSize: 13, color: '#64748b' }}>Loading activity…</div>;

  return (
    <div style={{ ...ui.card, marginBottom: 14 }}>
      <div style={{ fontWeight: 900, color: '#312e81', marginBottom: 8 }}>📊 My Paper Activity</div>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        <Stat label="Total Papers Generated" value={stats.totalPapersGenerated} color="#4f46e5" />
        <Stat label="Total Source Files Uploaded" value={stats.totalSourceFilesUploaded} color="#059669" />
        <Stat label="Downloads" value={stats.totalDownloads} color="#d97706" />
      </div>
      <div style={{ fontWeight: 800, fontSize: 13, margin: '12px 0 6px', color: '#3730a3' }}>Recent History</div>
      {stats.recentHistory.length === 0 ? (
        <div style={{ fontSize: 13, color: '#64748b' }}>No activity yet.</div>
      ) : stats.recentHistory.map((a) => (
        <div key={a._id} style={ui.listRow}>
          <span>{a.action === 'paper_downloaded' ? '⬇️' : '📄'}</span>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontWeight: 700, fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{a.title}</div>
            <div style={{ fontSize: 11, color: '#64748b' }}>
              {a.action === 'paper_downloaded' ? 'Downloaded' : 'Generated'} · Class {a.class || '-'} · {a.subject || '-'} · {fmt(a.timestamp)}
            </div>
          </div>
          {onOpenPaper && a.paperId && (
            <button style={ui.btnSmall} onClick={() => getPaper(user, a.paperId).then(onOpenPaper).catch((e) => setErr(errMsg(e)))}>Open</button>
          )}
        </div>
      ))}
      <button style={{ ...ui.btnGhost, marginTop: 8 }} onClick={() => setShowFiles((s) => !s)}>
        {showFiles ? 'Hide' : 'Show'} my uploaded files
      </button>
      {showFiles && <div style={{ marginTop: 8 }}><FileTable user={user} /></div>}
    </div>
  );
}

export default TeacherPaperStats;
